export const DEFAULT_TRUNCATE_SETTINGS = {
  length: 60,
  separator: /,? +/,
  omission: '...',
};
